import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

const AlertComponent = (title, mess, props, btnFunc, showAsToast = true, btnTxt = "OK", funcNo = null) => {
  const MySwal = withReactContent(Swal);

  let toastProps = {};
  if (showAsToast) {
    toastProps = {
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
      icon: "success",
      didOpen: (toast) => {
        toast.addEventListener("mouseenter", Swal.stopTimer);
        toast.addEventListener("mouseleave", Swal.resumeTimer);
      },
    };
  }

  let args = {
    ...toastProps,
    ...props,
  };

  args.title = title;
  args.text = mess;
  if (btnTxt) args.confirmButtonText = btnTxt;

  return MySwal.fire(args).then((result) => {
    if (result.isConfirmed && btnFunc) {
      btnFunc(result);
    } else if ((result.isDenied || result.isDismissed) && funcNo) {
      funcNo(result);
    }
  });
};

export default AlertComponent;
